import { useMutation } from '@tanstack/react-query'
import { changeParticipantSupervisor } from '../index'

const useChangeParticipantSupervisor = () =>
  useMutation({
    mutationFn: (payload: {
      consumerId: string
      newSupervisorUserId: string
    }) => changeParticipantSupervisor(payload),
  })

export { useChangeParticipantSupervisor }
